import React from 'react';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals.js';
import { ThemeProvider } from '@deere/fuel-react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <React.StrictMode>
        {/* HelmetProvider allows access to the Head of the page */}
        <HelmetProvider>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="msapplication-TileColor" content="#ffffff" />
                <meta name="theme-color" content="#ffffff" />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="180x180"
                    href="https://cdn.ux.deere.com/brand-foundations/1.3.1/favicons/green-favicon/apple-touch-icon.png"
                />
                <link
                    rel="icon"
                    type="image/png"
                    sizes="32x32"
                    href="https://cdn.ux.deere.com/brand-foundations/1.3.1/favicons/green-favicon/favicon-32x32.png"
                />
                <link
                    rel="icon"
                    type="image/png"
                    sizes="16x16"
                    href="https://cdn.ux.deere.com/brand-foundations/1.3.1/favicons/green-favicon/favicon-16x16.png"
                />
                <link
                    rel="manifest"
                    href="https://cdn.ux.deere.com/brand-foundations/1.3.1/favicons/green-favicon/site.webmanifest"
                />
                <link
                    rel="mask-icon"
                    href="https://cdn.ux.deere.com/brand-foundations/1.3.1/favicons/green-favicon/safari-pinned-tab.svg"
                    color="#367c2b"
                />
                <link
                    rel="preconnect"
                    href="https://cdn.ux.deere.com"
                    crossorigin
                />
                <link
                    rel="stylesheet"
                    href="https://cdn.ux.deere.com/brand-foundations/1.3.1/typography/fonts.css"
                />
            </Helmet>
            <ThemeProvider includeFonts={false}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </ThemeProvider>
        </HelmetProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
